import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const SaveDraftCart = async (formData: {
  id?: string | number | null;
  customer_id: number | null;
  table_id?: string | null;
  draft_name?: string | null;
  order_status_id?: string | null;
  cart_data: any;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/draft/save`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save draft cart.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const LoadDraftCart = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/cart/load`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load draft cart.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetDraftCartsList = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/draft/list`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load draft carts list.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const ClearDraftCart = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/cart/clear`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to clear draft cart.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteDraftCart = async (
  id: string | number,
  is_checkout: boolean = false,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/draft/delete`, {
      id,
      is_checkout,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete draft cart.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateDraftCartStatus = async (
  id: string | number,
  order_status_id: string | null,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/draft/update-status`, {
      id,
      order_status_id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to update draft order status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
